const directoryTypes = {
    GET_CITIES_PENDING: "GET_CITIES_PENDING",
    GET_CITIES_SUCCESS: "GET_CITIES_SUCCESS",
    GET_CITIES_ERROR: "GET_CITIES_ERROR",
}

export default directoryTypes;
